import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';
import { TradeInOffer, TradeInOfferPromo } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class TradeInApi {
    public static getTradeInOffer(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<TradeInOffer> {
        return http.get(`/tradein/offerid/${params.offerId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => TradeInOffer.create<TradeInOffer>({ ...response, offerId: params.offerId }))
        );
    }
    public static cancelTradeIn(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ApiResponse> {
        return http.post(`/tradein/offerid/${params.offerid}/cancel`, params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        });
    }

    public static submitTradeInDecision(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<ApiResponse> {
        return http.post('/tradein/offer/decision', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        });
    }

    public static tradeInOfferPromo(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<TradeInOfferPromo> {
        return http.post('/tradein/offers', params.payload, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY })
        }).pipe(
            map((response: ApiResponse) => TradeInOfferPromo.create<TradeInOfferPromo>({ ...response }))
        );
    }

}
ModelBase.fetchMapping[StoreAction.GET_TRADE_IN_OFFER_DATA] = TradeInApi.getTradeInOffer;
ModelBase.persistMapping[StoreAction.CANCEL_TRADE_IN_OFFER_DATA] = TradeInApi.cancelTradeIn;
ModelBase.persistMapping[StoreAction.SUBMIT_TRADE_IN_DECISION] = TradeInApi.submitTradeInDecision;
ModelBase.persistMapping[StoreAction.GET_TRADE_IN_OFFER_PROMO] = TradeInApi.tradeInOfferPromo;

